import React from 'react';

import { MtxGrid } from '@meilleurtaux/mtp-uikit-react';

import { PlacementDocumentItem } from '@/api';
import { DocumentsRow } from '@/components/ContractDocuments/DocumentRow/DocumentRow';

import styles from './styles.module.css';

export type PropsDocuments = {
  documentsInfos?: PlacementDocumentItem[] | null | undefined;
};

export const ContractDocuments: React.FC<PropsDocuments> = ({ documentsInfos: documentsData }) => {
  return (
    <MtxGrid row>
      <MtxGrid col={7} colXs={12} colSm={12} colMd={12} colLg={7}>
        <table className={styles.tableDocuments}>
          <tbody>
            {documentsData?.map((document) => (
              <DocumentsRow
                key={document.token ?? `${document.typeDocument}-${document.dateDocument}-${document.millesime}`}
                typeDocument={document.typeDocument}
                dateDocument={document.dateDocument}
                token={document.token}
                millesime={document.millesime}
              />
            ))}
          </tbody>
        </table>
      </MtxGrid>
    </MtxGrid>
  );
};
